module.exports = __webpack_public_path__ + "e2dc4532.svg";